// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ck.ck-dropdown.ck-wproofreader-empty .ck-dropdown__panel{display:none!important}", "",{"version":3,"sources":["webpack://./node_modules/@webspellchecker/wproofreader-ckeditor5/theme/wproofreader.css"],"names":[],"mappings":"AAAA,0DACC,sBACD","sourcesContent":[".ck.ck-dropdown.ck-wproofreader-empty .ck-dropdown__panel {\n\tdisplay: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
